import * as React from 'react';
import DialogButton from './DialogButton';
import { Box } from '@mui/material';

interface ICancelButtonProps {
  disabled?: boolean
  onClick(): void
}
  
class CancelButton extends React.Component<ICancelButtonProps> {
  render() {
    return (
      <Box mr={2}>
        <DialogButton variant="secondary" size="medium" onClick={this.props.onClick} disabled={this.props.disabled}>
          Cancel
        </DialogButton>
      </Box>
    )    
  }
}

export default CancelButton
